import * as React from 'react'
import './NodeBox.css';

import classNames from "classnames"
// import { ResizableBox } from 'react-resizable';
// import 'react-resizable/css/styles.css'

import Sizer, { Size } from './Sizer'

// A cute lil box which zooms its contents to fit it

interface Props {
  children: React.ReactNode,
  isOutput?: boolean,
  background?: string,
  zoomToFit?: boolean,
  width?: number,
  height?: number,
  minWidth?: number,
  divProps?: React.HTMLProps<HTMLDivElement>
}

interface State {
  contentsSize: Size | undefined,
  contentsZoom: number,
}

class NodeBox extends React.Component<Props, State> {

  state = { contentsZoom: 1, contentsSize: undefined as Size | undefined }

  render() {
    const {children, isOutput, background, divProps, /*width, height, zoomToFit*/} = this.props
    // const {contentsZoom} = this.state

    const interval = 20
    const roundUp = (x: number) => Math.max(Math.ceil(x / interval) * interval, 40)

    let width = this.state.contentsSize ? roundUp(this.state.contentsSize.width) : 80
    let height = this.state.contentsSize ? roundUp(this.state.contentsSize.height) : 80

    if (this.props.minWidth !== undefined) {
      width = Math.max(width, this.props.minWidth)
    }

    return (
      <div className={classNames("NodeBox", {"NodeBox-output": isOutput})} style={{background, width, height}}
            {...divProps}>
        <Sizer owner={this} stateName="contentsSize" className="NodeBox-contents">
          { children }
        </Sizer>
      </div>
    );
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    const {isOutput, zoomToFit, width, height} = props
    const {contentsSize, contentsZoom} = state

    if (!zoomToFit) {
      if (contentsZoom !== 1) {
        return { contentsZoom: 1 }
      } else {
        return null
      }
    }

    if (!width || !height) {
      return null
    }

    let desiredZoom = 1
    if (contentsSize) {
      const haloSpace = isOutput ? 10 : 0;

      // if (props.result) {
      //   console.log("result", props.result)
      //   console.log("width", boxSize.width - haloSpace - 5, contentsSize.width)
      //   console.log("height", boxSize.height - haloSpace - 5, contentsSize.height)
      // }

      desiredZoom = Math.min(
        (width - haloSpace - 5) / contentsSize.width,
        (height - haloSpace - 5) / contentsSize.height
      )
      // if (props.result) {
      //   console.log("desiredZoom", desiredZoom)
      // }

      desiredZoom = Math.min(desiredZoom, 10)
      // desiredZoom = Math.max(desiredZoom, 1)
    }

    if (!contentsZoom || Math.abs(Math.log(desiredZoom / contentsZoom)) > 0.1) {
      return { contentsZoom: desiredZoom }
    }

    return null
  }
}


export default NodeBox



// WEBPACK FOOTER //
// ./src/view/NodeBox.tsx